export default __webpack_public_path__ + "static/media/Right_Arrow_Inactive.ccf72e0a.svg";